import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { isEqual, isEmpty } from 'lodash'

import { Box } from '@mui/material'

import CheckboxList from 'components/pages/dis-v2/_components/CheckboxList'
import DriverEventsForm from '../driver-events/DriverEventsForm'
import { driverDrivesColumns } from './helper/constants'
import { driverDriveTileFieldIdMap } from 'utils/params/helpers'
import DriverTileLabel from './DriverTileLabel'

const DEFAULT_PRIMARY_KEY_LIST = ['Drive_Id']

export default function DriverDrivesForm(props) {
	const { dashboardKeyList, filterData, onFilterDataChange } = props
	const [t] = useTranslation('common')

	const [primaryKeyList, setPrimaryKeyList] = useState(DEFAULT_PRIMARY_KEY_LIST)

	const [formattedColumnsChecked, setFormattedColumnsChecked] = useState([])
	useEffect(() => {
		if (isEmpty(filterData?.primaryKeyList)) {
			onFilterDataChange('primaryKeyList', DEFAULT_PRIMARY_KEY_LIST)
			return
		}

		if (!isEqual(filterData?.primaryKeyList, primaryKeyList)) {
			setPrimaryKeyList(filterData?.primaryKeyList || DEFAULT_PRIMARY_KEY_LIST)
		}
	}, [filterData?.primaryKeyList])

	useEffect(() => {
		if (
			isEmpty(filterData?.columnsChecked) &&
			!isEqual(filterData?.columnsChecked, formattedColumnsChecked)
		) {
			setFormattedColumnsChecked([])
			return
		}

		const newColumnsChecked = filterData?.columnsChecked
			?.map((columnChecked) => {
				let a = driverDrivesColumns.find((column) => column.name === columnChecked)
				if (a) return columnChecked

				a = driverDrivesColumns.find((column) => column.driverDriveKey === columnChecked)
				if (a) return a.name

				return null
			})
			.filter((item) => !!item)

		if (isEqual(newColumnsChecked, formattedColumnsChecked)) return
		setFormattedColumnsChecked(newColumnsChecked)
	}, [filterData?.columnsChecked])

	const handleColumnsCheck = (value) => () => {
		const columnsChecked = formattedColumnsChecked || []
		const currentIndex = columnsChecked?.indexOf(value)
		const newChecked = [...columnsChecked]

		if (currentIndex === -1) {
			newChecked.push(value)
		} else {
			newChecked.splice(currentIndex, 1)
		}
		onFilterDataChange('columnsChecked', newChecked)
	}

	const handleSetPrimaryKey = (id) => {
		if (primaryKeyList.includes(id)) {
			onFilterDataChange(
				'primaryKeyList',
				primaryKeyList.filter((item) => item !== id)
			)
		} else {
			onFilterDataChange('primaryKeyList', [...primaryKeyList, id])
		}
	}

	return (
		<DriverEventsForm
			filterData={filterData}
			onFilterDataChange={onFilterDataChange}
			dashboardKeyList={dashboardKeyList}
			additionalSettingComponent={
				<Box>
					<CheckboxList
						title={t('common:dis.selectFields')}
						enableIcon={true}
						enableCheckbox={true}
						onIconClick={handleSetPrimaryKey}
						checkedIconList={primaryKeyList}
						data={driverDrivesColumns}
						onItemClick={handleColumnsCheck}
						checkedList={formattedColumnsChecked || []}
						getLabel={(option) => option.title}
						getValue={(option) => option.name}
					/>
				</Box>
			}
			tileLabelComponent={
				<DriverTileLabel
					title={t('common:dis.tileLabel')}
					firstLabel={filterData?.firstLabel}
					secondLabel={filterData?.secondLabel}
					fields={dashboardKeyList}
					handleSettingsChange={onFilterDataChange}
				/>
			}
			otherOptions={[
				{
					label: t('common:chart.enableDataExport'),
					value: 'enableExport',
				},
			]}
		/>
	)
}
